import { module } from 'modujs'
import modularLoad from 'modularload'
import { CUSTOM_EVENT, ENV, VARS } from '../config'
import { resetLazyloadCallbacks, triggerLazyloadCallbacks } from '../utils/image'

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 250,
            transitions: {
                listing: {
                    loadingClass: 'is-loading-transition-listing',
                    enterDelay: 250
                }
            }
        })

        const readyEvent = new CustomEvent(CUSTOM_EVENT.READY)

        this.load?.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app')
            this.call('update', newContainer, 'app')
            window.dispatchEvent(readyEvent)

            if (transition === 'listing') {
                this.call('addScrollElements', newContainer, 'Scroll')

                setTimeout(() => {
                    const scrollToDuration = 0.5
                    const $target = document.querySelector('.c-filters')
                    this.call('update', null, 'Scroll')
                    this.call('scrollTo', { target: $target, offset: -120, duration: scrollToDuration }, 'Scroll')
                    newContainer.querySelector('.c-thumb_link')?.focus()

                    setTimeout(() => {
                        this.call('unlockReduced', null, 'Header')
                    }, scrollToDuration * 1000)
                }, 100);
            }

            /**
             * Trigger lazyload
             */
            triggerLazyloadCallbacks()
        })

        this.load?.on('loading', (transition, oldContainer) => {

            resetLazyloadCallbacks()

            if(transition === 'listing') {
                this.call('removeScrollElements', oldContainer, 'Scroll')
                this.call('lockReduced', true, 'Header')
            } else {
                this.call('start', null, 'Loader')
            }

        })

        // Accessibility navigation backward fix
        // SHIFT + TAB
        if(!ENV.IS_TOUCH) {
            let shiftDown = false
            let tabDown = false

            document.addEventListener('keydown', e => {
                if (['ShiftLeft', 'AltLeft'].includes(e.code)) {
                    shiftDown = true
                } else if (e.code == 'Tab') {
                    tabDown = true
                }
            })

            document.addEventListener('keyup', e => {
                if (['ShiftLeft', 'AltLeft'].includes(e.code)) {
                    shiftDown = false
                } else if (e.code == 'Tab') {
                    tabDown = false
                }
            })

            document.addEventListener('focusin', () => {
                if(shiftDown && tabDown) {
                    const $activeElement = document.activeElement
                    const offsetTop = $activeElement?.getBoundingClientRect().top
                    if(offsetTop < VARS.headerHeight) {
                        requestAnimationFrame(() => {
                        this.call('scrollTo', { target: $activeElement, immediate: true }, 'Scroll')
                        })
                    }
                }
            }, true)
        }
    }

    goTo(obj) {
        this.load?.goTo(obj.url, obj.transition)
    }
}
